import React, { useState } from 'react';
import { FaInfoCircle, FaTimes, FaChessKnight, FaClock, FaVideoSlash, FaLayerGroup, FaChartPie, FaChartBar, FaPlayCircle, FaFlask, FaCheckCircle } from 'react-icons/fa';

const StatisticsInfoModal = ({ isOpen, onClose, mode = 'logic' }) => {
    if (!isOpen) return null;

    return (
        <div className="stats-modal-overlay" onClick={onClose} style={{ zIndex: 10001 }}>
            <div className="stats-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px', padding: '0' }}>
                <div className="stats-header" style={{ padding: '15px 20px', borderBottom: '1px solid #eee' }}>
                    <div className="header-title">
                        <FaInfoCircle className="header-icon" style={{ color: '#3498db' }} />
                        <h2 style={{ fontSize: '18px' }}>Baholash Tizimi Haqida</h2>
                    </div>
                    <button className="close-btn" onClick={onClose}><FaTimes /></button>
                </div>

                <div className="stats-body" style={{ padding: '20px' }}>
                    <div className="stats-scroll-content" style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '5px' }}>

                        <h3 style={sectionTitleStyle}>1. Yechimlar Foizi (Pie Chart)</h3>
                        <p style={{ ...descStyle, marginBottom: '15px' }}>
                            Ushbu diagramma tanlangan bo'limdagi jami masalalar va siz yechgan masalalar nisbatini ko'rsatadi. <br />
                            <span style={{ color: '#2ecc71', fontWeight: 'bold' }}>Yashil:</span> Yechilganlar. <br />
                            <span style={{ color: '#e74c3c', fontWeight: 'bold' }}>Qizil:</span> Hali yechilmaganlar.
                        </p>

                        <h3 style={sectionTitleStyle}>2. Mantiqiy Salohiyat (Radar Chart)</h3>
                        <p style={{ ...descStyle, marginBottom: '10px' }}>
                            Sizning mantiqiy fikrlash qobiliyatingiz 4 ta asosiy mezon bo'yicha baholanadi:
                        </p>

                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            {mode === 'logic' ? (
                                <>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#9b59b2')}><FaVideoSlash /></div>
                                        <div>
                                            <h4 style={titleStyle}>Mustaqillik</h4>
                                            <p style={descStyle}>Video yordamisiz yechilgan masalalar ulushi. Video ko'rish bu ballni pasaytiradi.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#e67e22')}><FaClock /></div>
                                        <div>
                                            <h4 style={titleStyle}>Tezlik</h4>
                                            <p style={descStyle}>Masala qiyinligiga nisbatan yechish tezligi. Qiyin masalaga ko'proq vaqt ajratiladi.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#2ecc71')}><FaChessKnight /></div>
                                        <div>
                                            <h4 style={titleStyle}>Yechimlar Foizi</h4>
                                            <p style={descStyle}>Ushbu bo'limdagi barcha masalalarning qanchasini uddaladingiz.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#34495e')}><FaLayerGroup /></div>
                                        <div>
                                            <h4 style={titleStyle}>Barqarorlik</h4>
                                            <p style={descStyle}>Qancha ko'p masala yeksangiz, natijangiz shunchalik ishonchli (barqaror) bo'ladi.</p>
                                        </div>
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#3498db')}><FaChartPie /></div>
                                        <div>
                                            <h4 style={titleStyle}>O'zlashtirish (Progress)</h4>
                                            <p style={descStyle}>Kursning qancha qismi tugatilgani. Dars "tugatilgan" hisoblanishi uchun testdan kamida <b>4 ball</b> olishingiz shart.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#9b59b2')}><FaPlayCircle /></div>
                                        <div>
                                            <h4 style={titleStyle}>Izlanish (Video)</h4>
                                            <p style={descStyle}>Darslarni chuqur o'rganish. Video darslarni qancha ko'p ko'rsangiz, ball shuncha oshadi.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#e67e22')}><FaFlask /></div>
                                        <div>
                                            <h4 style={titleStyle}>Test Natijasi</h4>
                                            <p style={descStyle}>Bilim sifati. Testlarni <b>birinchi urinishdayoq</b> xatosiz ishlashga harakat qiling.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#f39c12')}><FaLayerGroup /></div>
                                        <div>
                                            <h4 style={titleStyle}>Amaliyot (Bonus)</h4>
                                            <p style={descStyle}>Olingan bilimni amalda qo'llash. Amaliy topshiriqlarni bajarish ballingizni <b>ikki barobar</b> oshiradi.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#2ecc71')}><FaClock /></div>
                                        <div>
                                            <h4 style={titleStyle}>Tezlik</h4>
                                            <p style={descStyle}>Testlarni ishlash tezligi. O'ylash uchun yetarli vaqt sarflang, shoshilmang.</p>
                                        </div>
                                    </li>
                                    <li style={itemStyle}>
                                        <div style={iconBoxStyle('#34495e')}><FaCheckCircle /></div>
                                        <div>
                                            <h4 style={titleStyle}>Faollik (Barqarorlik)</h4>
                                            <p style={descStyle}>Darslarni <b>har kuni</b> qilish muhim. Agar har kuni kamida bitta dars qilsangiz, bu ball yuqori bo'ladi.</p>
                                        </div>
                                    </li>
                                </>
                            )}
                        </ul>

                        <h3 style={sectionTitleStyle}>3. Vaqt Tahlili (Bar Chart)</h3>
                        <p style={{ ...descStyle, marginBottom: '10px' }}>
                            Har bir masala uchun sarflagan vaqtingizni ko'rsatadi.
                        </p>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            <li style={itemStyle}>
                                <div style={iconBoxStyle('#3498db')}><FaClock /></div>
                                <div>
                                    <h4 style={titleStyle}>Aniq Vaqt</h4>
                                    <p style={descStyle}>Har bir ustun bitta masalani bildiradi. Balandligi - unga ketgan vaqt (soniyalarda). Qanchalik past bo'lsa, shuncha yaxshi.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

const itemStyle = {
    display: 'flex',
    gap: '15px',
    marginBottom: '20px',
    alignItems: 'flex-start'
};

const iconBoxStyle = (color) => ({
    minWidth: '40px',
    height: '40px',
    borderRadius: '10px',
    background: `${color}20`,
    color: color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px'
});

const titleStyle = {
    margin: '0 0 5px 0',
    fontSize: '15px',
    fontWeight: '600',
    color: '#333'
};

const descStyle = {
    margin: 0,
    fontSize: '13px',
    color: '#777',
    lineHeight: '1.4'
};

const sectionTitleStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#2c3e50',
    marginTop: '20px',
    marginBottom: '10px',
    borderBottom: '2px solid #f1f2f6',
    paddingBottom: '5px'
};

export default StatisticsInfoModal;
